// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2BiVt","fileBtn":"File_fileBtn__3P3ze","closeBtn":"File_closeBtn__3LX5b","fileSelected":"File_fileSelected__1sD54","disabled":"File_disabled__Guhdk"};